/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Strategy feasibility ratings
 */
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export type StrategyFeasibilityRatingEnum = 'Low' | 'Medium' | 'High' | 'Very High';

export const StrategyFeasibilityRatingEnum = {
    Low: 'Low' as StrategyFeasibilityRatingEnum,
    Medium: 'Medium' as StrategyFeasibilityRatingEnum,
    High: 'High' as StrategyFeasibilityRatingEnum,
    VeryHigh: 'Very High' as StrategyFeasibilityRatingEnum
};

marker('Low');
marker('Medium');
marker('High');
marker('Very High');

